import { render, staticRenderFns } from "./order-stock-edit.vue?vue&type=template&id=b0480d82&scoped=true&"
import script from "./order-stock-edit.vue?vue&type=script&lang=js&"
export * from "./order-stock-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0480d82",
  null
  
)

export default component.exports